import { SharedOwnedBusinessEntities } from "../../../shared/lib/types";

export const filterNotCurrentOwnedBusinessEntities = (
  ownedBusinessEntities: NonNullable<SharedOwnedBusinessEntities>,
) =>
  ownedBusinessEntities.all.filter(
    (ownedBusinessEntity) =>
      ownedBusinessEntity.code !== ownedBusinessEntities.current.code,
  );
